/**
 * Timezone validation helpers used by the Account page admin settings.
 * Browsers throw RangeError on Date#toLocaleString({ timeZone: 'foo' }) when
 * the IANA name is invalid — these helpers contain that to keep the UI safe.
 */

// Validate an IANA timezone string; return it if valid, else fallback.
export const safeTz = (tz, fallback = "Europe/London") => {
  if (!tz || typeof tz !== "string") return fallback;
  try {
    new Date().toLocaleString("en-GB", { timeZone: tz });
    return tz;
  } catch {
    return fallback;
  }
};

// Format a UTC ISO string in a given host timezone. Never throws — returns "—" on bad inputs.
export const fmtHostLocal = (iso, hostTz) => {
  try {
    return new Date(iso).toLocaleString("en-GB", {
      timeZone: safeTz(hostTz),
      weekday: "short",
      day: "numeric",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return "—";
  }
};
